const LISTING_PAGE_TYPES = new Set(['Listing', 'ListingHybrid', 'ListingJK']);

export function isListingIframePageview(eventParams: { page?: { pageType?: unknown } } | null | undefined): boolean {
  const pageType = eventParams?.page?.pageType;

  return typeof pageType === 'string' && LISTING_PAGE_TYPES.has(pageType);
}
